import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TPipe } from '../../core/i18n/t.pipe';

@Component({
    selector: 'charla-medium',
    template: `
            <div class="medium" *ngIf="status == 'offline'" >
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect id="bound" x="0" y="0" width="24" height="24"/>
                            <circle id="Oval-5" fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                            <rect id="Rectangle-9" fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                            <rect id="Rectangle-9-Copy" fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                        </g>
                    </svg>
                </div>
                <div>
                    {{ 'inbox.status.medium.visitor_has_been_offline_for_a_while' | t:'Visitor has been offline for a while.' }}
                    {{ email ? 
                    ('inbox.status.medium.message_will_be_delivered_to_both' | t:'Message will be delivered to both chat and email ({{email}}).':{email: email}) : 
                    ('inbox.status.medium.message_is_not_guaranteed_to_reach' | t:'Message is not guaranteed to reach him. Add an email to his profile to deliver to both chat and email.') }}
                </div>
            </div>
        `,
    styles: [' .medium { display: flex; gap: 5px;  }'],
    imports: [TPipe, CommonModule]
})
export class MediumComponent implements OnInit {
    
    sub: Subscription;
    status: string = "offline";

    @Input() lastSeen: string;    
    @Input() offlineAt: string;
    @Input() email: string = "";

    constructor(private cd: ChangeDetectorRef){

    }
    
    ngOnInit() {
        this.setupTimer();
    }

    calculateStatus(){

        if (this.lastSeen == undefined) {
            this.status = 'offline';
            this.cd.detectChanges();
            return;
        }

        let n = moment.utc();
        let sd = moment.utc( this.lastSeen.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss');

        if (this.offlineAt){
            let off = moment.utc( this.offlineAt.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss');
            if (off > sd){
                this.status = 'offline';
                this.cd.detectChanges();
                return;    
            }
        }

        let diff = Math.abs( n.diff(sd, 'seconds') );
        let st = 'offline';

        if (diff <= (environment.sessionDuration / 2) ) {
            st = 'online';
        }
        else if (diff <= environment.sessionDuration) {
            st = 'away';
        }

        this.status = st;

        this.cd.detectChanges();
    }

    setupTimer(){
        
        if (this.sub) this.sub.unsubscribe();

		this.sub = timer(0, 1000 * 60).subscribe( () => {
			this.calculateStatus();
			//console.debug(`Refreshing visitor status (${this.lastSeen})...`);
        });
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if( changes['lastSeen'] || changes['offlineAt'] ) {
            this.setupTimer();
        }
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

}